import React from 'react';
import { useDispatch } from 'react-redux';
import ContentConstants from '../../../contentConstants';
import { ActionCreators } from '../../../store/SurveyStore';
import { Col3Col9, CounterPill, Crumblist, ICrumb, ISelectOption, SearchBoxWithFilter } from '@aon/aon-tws-common-ui';
import { LabelAbove } from '@aon/tws-common-ui-questions/build/lib/components/common';
import { SurveyHelper } from '../../../utilities';
import _ from 'lodash';
import { CrumblistContainer } from '../../common';

export interface ISurveyAdditionalLanguagesProps {
	availableAdditionalCultures: ISelectOption[];
	culturesLoading: boolean;
	defaultCultureCode: string;
	selectedAdditionalCultures: ISelectOption[];
}

export function SurveyAdditionalLanguages(props: ISurveyAdditionalLanguagesProps) {
	const { availableAdditionalCultures, culturesLoading, defaultCultureCode, selectedAdditionalCultures } = props;
	const dispatch = useDispatch();

	const selectedCultureCrumbs = SurveyHelper.getCrumbsFromSelectOptions(selectedAdditionalCultures);

	function handleUpdateCultureSelect(cultures: ISelectOption[]) {
		let cultureCodes = _.map(cultures, (c: ISelectOption) => c.name);
		if (defaultCultureCode) {
			cultureCodes = [defaultCultureCode].concat(cultureCodes);
		}
		dispatch(ActionCreators.UpdateSelectedCultures(cultureCodes));
	}

	function handleUpdateCultureCrumbs(cultures: ICrumb[]) {
		let cultureCodes = _.map(cultures, (c: ICrumb) => c.value);
		if (defaultCultureCode) {
			cultureCodes = [defaultCultureCode].concat(cultureCodes);
		}
		dispatch(ActionCreators.UpdateSelectedCultures(cultureCodes));
	}

	return (
		<Col3Col9
			className='tws-survey-additional-languages'
			label={ContentConstants.SUBSECTIONHEADERS_ADDITIONAL_LANGUAGES}
			subLabelDisplayData={<CounterPill actualCount={selectedAdditionalCultures.length} />}
		>
			<LabelAbove type='input'>{ContentConstants.SECTION_DESCRIPTION_ADDITIONAL_LANGUAGES}</LabelAbove>
			{!culturesLoading && (
				<SearchBoxWithFilter
					placeholderText={ContentConstants.INPUT_PLACEHOLDER_SEARCH_FOR_LANGUAGES}
					items={availableAdditionalCultures}
					selected={selectedAdditionalCultures}
					select={handleUpdateCultureSelect}
					filterOutSelected={true}
				/>
			)}
			<CrumblistContainer>
				{selectedCultureCrumbs.length > 0 && (
					<Crumblist enableDismiss={true} data={selectedCultureCrumbs} update={handleUpdateCultureCrumbs} />
				)}
			</CrumblistContainer>
		</Col3Col9>
	);
}
